import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Boom from "../components/boom"

const PricePage = () => (
  <Layout>
    <Seo title="harga layanan whatsapp shop" />
    <div className="col-12 col-md-12 p-3 p-md-5 text-center"
	   style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}>
<StaticImage
className="rounded shadow"
      src="../images/cloud.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
    </div>
    <div className="col-12 col-md-12 p-3 p-md-5 text-center"
      style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}
      >
	  
<div class="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
<h1><a href="/price" className="text-dark">Whatshop Pricing</a></h1>
<p>Layanan dengan durasi pertahun</p>
<div className="row">

<div className="col-12 col-md-4">
	 <div className="p-3 p-md-5 card shadow rounded bg-dark text-white">
	 <div className="text-center p-1 rounded text-dark"
	 style={{
backgroundRepeat: 'repeat',
backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
}}>
<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor" className="bi bi-cart-check" viewBox="0 0 16 16">
  <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"/>
  <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
</svg>
<h3>Basic<br/>Rp.750.000</h3>
</div>
<hr/>
<p>Whatshop Apps</p><hr/>
<p>Domain com</p><hr/>
<p>Cloud Host</p><hr/>
<p>500MB Web Space</p><hr/>
<p>Web Online Shop</p><hr/>
<p>QR Code website</p><hr/>
<h3><a href="https://wa.me/62895339403223?text=Admin%20saya%20mau%20order%20Whatsappshop%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20%3AWhasthop-Standard%0APrice%20%3ARp.750.000/tahun%0APembayaran%20via%20%3A%0ABCA%200181884109%20Suci%20Chanifah%0Atolong%20diproses%20pesanan%20saya" class="btn btn-warning col-12"  
style={{
backgroundRepeat: 'repeat',
backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
}}>Order Now</a></h3>
</div>
</div>

<div className="col-12 col-md-4">
	 <div className="p-3 p-md-5 card shadow rounded bg-dark text-white">
	 <div className="text-center p-1 rounded text-dark"
	 style={{
backgroundRepeat: 'repeat',
backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
}}>
<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor" className="bi bi-cart-plus" viewBox="0 0 16 16">
  <path d="M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9V5.5z"/>
  <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
</svg>
<h3>Standard<br/>Rp.1.568.400</h3>
</div>
<hr/>
<p>Whatshop Apps</p><hr/>
<p>Domain com</p><hr/>
<p>+ Aplikasi Kasir Basic</p><hr/>
<p>+ APK Android</p><hr/>
<p>Cloud Host</p><hr/>
<p>1000MB Web Space</p><hr/>
<p>Web Online Shop</p><hr/>
<p>QR Code website</p><hr/>
<h3><a href="https://wa.me/62895339403223?text=Admin%20saya%20mau%20order%20Whatsappshop%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20%3AWhasthop-Standard%0APrice%20%3ARp.1.568.400/tahun%0APembayaran%20via%20%3A%0ABCA%200181884109%20Suci%20Chanifah%0Atolong%20diproses%20pesanan%20saya" class="btn btn-warning col-12"  style={{
backgroundRepeat: 'repeat',
backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
}}>Order Now</a></h3>
</div>
</div>

<div className="col-12 col-md-4">
	 <div className="p-3 p-md-5 card shadow rounded bg-dark text-white">
	 <div className="text-center p-1 rounded text-dark"
	 style={{
backgroundRepeat: 'repeat',
backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
}}>
<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor" className="bi bi-cart-plus" viewBox="0 0 16 16">
  <path d="M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9V5.5z"/>
  <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
</svg>
<h3>Premium<br/>Rp.3.568.400</h3>
</div>
<hr/>
<p>Whatshop Apps</p><hr/>
<p>Domain com</p><hr/>
<p>+ Aplikasi Kasir</p><hr/>
<p>+ APK Android</p><hr/>
<p>Cloud Host</p><hr/>
<p>1500MB Web Space</p><hr/>
<p>Web Online Shop</p><hr/>
<p><strong>Point of Sale App Pro</strong></p><hr/>
<p>QR Code website</p><hr/>
<h3><a href="https://wa.me/62895339403223?text=Admin%20saya%20mau%20order%20Whatsappshop%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20%3AWhasthop-Premium%0APrice%20%3ARp.3.568.400/tahun%0APembayaran%20via%20%3A%0ABCA%200181884109%20Suci%20Chanifah%0Atolong%20diproses%20pesanan%20saya" class="btn btn-warning col-12"  style={{
backgroundRepeat: 'repeat',
backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
}}>Order Now</a></h3>
</div>
</div>
</div>
</div>
</div>
	
			<Boom/>
      </Layout>
)

export default PricePage
